import styled from 'react-emotion';

const FieldHelp = styled.div`
  color: ${p => p.theme.gray2};
  font-size: 14px;
  margin-top: 8px;
  line-height: 1.4;
`;

export default FieldHelp;



// WEBPACK FOOTER //
// ./app/views/settings/components/forms/field/fieldHelp.jsx